export const LIST_VIEW = 'LIST_VIEW'
export const TABLE_VIEW = 'TABLE_VIEW'

export const DEFAULT_ITEM_PER_PAGE = 50

export const DEFAULT_SPECIES = ['dmel', 'hsap', 'other']
